export const colours = {
  primaryButton: '#3F8882',
  secondaryButton: '#072C45',
  tertiaryButton: '#111E26',
  blockColor1: '#162524',
  blockColor2: '#043D38',
  primaryFont: '#ffffff',
  success: {
    main: '#4CAF50',
    focus: '#67bb6a'
  },
  warning: {
    main: '#fb8c00',
    focus: '#fc9d26'
  },
  error: {
    main: '#F44335',
    focus: '#f65f53'
  }
}

export default colours